import { PromotionType } from '../types/offers';

export const orderAndSortOffers = (offers: PromotionType[]) => {
  const offersCopy = [...offers];

  const programGroups = {
    lease: offersCopy.filter((offer) => offer.offerType === 'lease'),
    credit: offersCopy.filter((offer) => offer.offerType === 'credit'),
    finance: offersCopy.filter((offer) => offer.offerType === 'finance'),
  };

  const counts = {
    lease: programGroups.lease.length,
    finance: programGroups.finance.length,
    credit: programGroups.credit.length,
  };

  const totalCount = counts.lease + counts.finance + counts.credit;

  // if we have 6 or less offers - returning them all back
  if (totalCount <= 6) {
    return offersCopy;
  }

  // Initialize take with ideal distribution of 2 per type
  const take = {
    lease: Math.min(counts.lease, 2),
    credit: Math.min(counts.credit, 2),
    finance: Math.min(counts.finance, 2),
  };

  // Calculate how many slots we've filled and how many we still need to fill
  const totalTaken = take.lease + take.finance + take.credit;
  let slotsRemaining = 6 - totalTaken;

  // If we need to fill more slots, distribute them among program types that have extras
  if (slotsRemaining > 0) {
    // Calculate how many extras we have of each type
    const extras = {
      lease: Math.max(0, counts.lease - take.lease),
      credit: Math.max(0, counts.credit - take.credit),
      finance: Math.max(0, counts.finance - take.finance),
    };

    // Distribute remaining slots, prioritizing by type (lease first, then credit, then finance)
    while (slotsRemaining > 0) {
      // Check in priority order: lease -> credit -> finance
      if (extras.lease > 0) {
        take.lease += 1;
        extras.lease -= 1;
        slotsRemaining -= 1;
      } else if (extras.credit > 0) {
        take.credit += 1;
        extras.credit -= 1;
        slotsRemaining -= 1;
      } else if (extras.finance > 0) {
        take.finance += 1;
        extras.finance -= 1;
        slotsRemaining -= 1;
      } else {
        break;
      }
    }
  }

  // Create the result array by taking the calculated number from each type
  // Order the result by priority: lease first, then credit, then finance
  const result = [
    ...programGroups.lease.slice(0, take.lease),
    ...programGroups.credit.slice(0, take.credit),
    ...programGroups.finance.slice(0, take.finance),
  ];

  return result;
};

export const sortOffers = (offers: PromotionType[]) => {
  const order = { lease: 1, credit: 2, finance: 3 };
  const sortedByPriority = offers.sort((a, b) => {
    // @ts-ignore
    const typeComparison = order[a.offerType] - order[b.offerType];

    if (typeComparison !== 0) {
      return typeComparison;
    }

    if (a.programPriority === 2 && b.programPriority !== 2) {
      return -1;
    }
    if (a.programPriority !== 2 && b.programPriority === 2) {
      return 1;
    }
    return 0;
  });
  const sortydByBestOffer = sortedByPriority.sort((a, b) => {
    if (a.offerType === 'lease' && b.offerType === 'lease') {
      return a.monthlyPayment - b.monthlyPayment;
    }
    if (a.offerType === 'credit' && b.offerType === 'credit') {
      return b.creditBonus - a.creditBonus;
    }
    if (a.offerType === 'finance' && b.offerType === 'finance') {
      return a.aprRate - b.aprRate;
    }
    return 0;
  });
  return sortydByBestOffer;
  // return sortedByPriority;
};
